import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { errorsMessage } from "../../helpers";
import { api } from "../../services/api";

export function useImovelPdf() {
  const [loadingPdf, setLoadingPdf] = useState(false);

  const exportarPdf = async (filtros = {}) => {
    setLoadingPdf(true);
    try {
      // Monta filters igual ao handleFilter do useImovel
      const filters = {};
      if (filtros.term)            filters.term           = filtros.term;
      if (filtros.idtipoimovel)    filters.idtipoimovel   = filtros.idtipoimovel;
      if (filtros.idtransacao)     filters.idtransacao    = filtros.idtransacao;
      if (filtros.IdSituacao)      filters.IdSituacao     = filtros.IdSituacao;
      if (filtros.grupo)           filters.grupo          = filtros.grupo;
      if (filtros.referencia)      filters.referencia     = filtros.referencia;
      if (filtros.IdPessoa)        filters.IdPessoa       = filtros.IdPessoa;
      if (filtros.IdCaptadoPor)    filters.IdCaptadoPor   = filtros.IdCaptadoPor;
      if (filtros.idFilial)        filters.idFilial       = filtros.idFilial;
      if (filtros.IdEmpreendimento) filters.IdEmpreendimento = filtros.IdEmpreendimento;
      if (filtros.IdObra)          filters.IdObra         = filtros.IdObra;
      if (filtros.IdUnidade)       filters.IdUnidade      = filtros.IdUnidade;
      if (filtros.valorinicial)    filters.valorinicial   = filtros.valorinicial;
      if (filtros.valorfinal)      filters.valorfinal     = filtros.valorfinal;
      if (filtros.dateStart)       filters.dateStart      = filtros.dateStart;
      if (filtros.dateEnd)         filters.dateEnd        = filtros.dateEnd;
      if (filtros.permuta)         filters.permuta        = filtros.permuta;
      if (filtros.oferta)          filters.oferta         = filtros.oferta;
      if (filtros.destaque)        filters.destaque       = filtros.destaque;
      if (filtros.lancamento)      filters.lancamento     = filtros.lancamento;
      if (filtros.comFoto)         filters.comFoto        = filtros.comFoto;
      if (filtros.semFoto)         filters.semFoto        = filtros.semFoto;

      // responseType blob é essencial para receber PDF
      const response = await api.get("/pdf/imoveis", {
        params: { filters },
        responseType: "blob",
      });

      const url = URL.createObjectURL(new Blob([response.data]));
      const a   = document.createElement("a");
      a.href     = url;
      a.download = "relatorio-imoveis.pdf";
      a.click();
      URL.revokeObjectURL(url);

      enqueueSnackbar("PDF gerado com sucesso", { variant: "success" });
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    } finally {
      setLoadingPdf(false);
    }
  };

  return { loadingPdf, exportarPdf };
}